import React from 'react';
import {compose, graphql} from 'react-apollo';
import Loading from "components/Loading";
import PropTypes from "prop-types";

import {requireLoggedUser} from "helpers/login";

import OperatorQuery from 'gql/operator/operator.gql';
import ChangeOnlineMutation from 'gql/operator/changeOnline.gql';

export function withOperator(WrappedComponent) {
    class WithOperator extends React.Component {
        static propTypes = {
            user: PropTypes.object.isRequired,
            operatorQuery: PropTypes.object.isRequired,
            changeOnline: PropTypes.func.isRequired,
        };

        constructor(props) {
            super(props);

            this.changeOnline = this.changeOnline.bind(this);
        }

        changeOnline(online) {
            return this.props.changeOnline({
                variables: {
                    operator: this.props.user.id,
                    online
                }
            });
        }

        render() {
            const {operatorQuery} = this.props;

            if (!operatorQuery || !operatorQuery.operator) {
                return <Loading/>
            }

            return <WrappedComponent operator={operatorQuery.operator} onOnlineChange={this.changeOnline} {...this.props}/>
        }
    }

    return compose(
        requireLoggedUser,
        graphql(OperatorQuery, {
            name: 'operatorQuery',
            options: {
                fetchPolicy: 'cache-only',
            }
        }),
        graphql(ChangeOnlineMutation, {name: 'changeOnline'}),
    )(WithOperator);
}


// WEBPACK FOOTER //
// ./src/helpers/operator.js